import * as React from 'react';

import { VALID_MEDIA_STYLES } from '../../Utils';
import { VALID_EDGE_STYLE_DATA } from '../../Utils/Styles/calcEdgeStyles';

import { IHeadingCommonProps, VALID_HEADING_LEVELS } from './common';
import { StyledHeading } from './StyledHeading';

export interface IHeadingProps extends IHeadingCommonProps {
  children: React.ReactNode;
  margin?: VALID_EDGE_STYLE_DATA;
  order?: VALID_MEDIA_STYLES;
}

const makeHeadingLevel = (level: VALID_HEADING_LEVELS): React.FC<Omit<IHeadingProps, 'level'>> =>
({
  align,
  alignSelf,
  flexBasis,
  flexGrow,
  flexShrink,
  children,
  margin,
  order,
  ...rest
}) => (
  <StyledHeading
    {...rest}
    as={level}
    align={align}
    alignSelf={alignSelf}
    flexBasis={flexBasis}
    flexGrow={flexGrow}
    flexShrink={flexShrink}
    level={level}
    marginProp={margin}
    orderProp={order}
  >
    {children}
  </StyledHeading>
);

const Headings: Record<VALID_HEADING_LEVELS, React.FC<Omit<IHeadingProps, 'level'>>> = {
  h1: makeHeadingLevel('h1'),
  h2: makeHeadingLevel('h2'),
  h3: makeHeadingLevel('h3'),
  h4: makeHeadingLevel('h4'),
  h5: makeHeadingLevel('h5'),
  h6: makeHeadingLevel('h6'),
};

export default Headings;

// stylguidist requires a react component to be exported to generate a place in the styleguide
export const Heading: React.FC = () => <div>dummy</div>;
